import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import '@/assets/icons'
import './plugins/vant'
import './plugins/currency-format'
// import './plugins/sentry'
import './plugins/iview'
import i18n from './plugins/i18n'
import gitLogger from '@/utils/git-logger'
import '@/plugins/fragment'
import '@/assets/css/global.css'
import globalComponents from '@/components'
import store from './store'
Vue.use(globalComponents)

Vue.config.productionTip = false
gitLogger()

export const vm = new Vue({
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
